import { FC, ReactNode } from 'react';
import './Table.scss';

type TableProps = {
  className?: string;
  content: ReactNode;
  scrollHorizontal?: boolean;
};

const Table: FC<TableProps> = ({ className, content, scrollHorizontal }) => {
  const wrapperClassName = scrollHorizontal
    ? 'card card-bordered card-preview table-responsive'
    : 'card card-bordered card-preview';

  const defaultTableClassName = 'table custom-table';

  return (
    <div className={wrapperClassName}>
      <table className={className || defaultTableClassName}>{content}</table>
    </div>
  );
};

export default Table;
